import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * Word-by-word masked reveal. Accepts a string or an array of
 * strings / { text, em: true } tokens so headlines can mix italics.
 */
export default function SplitText({
  text,
  as: Tag = 'h1',
  className,
  delay = 0,
  stagger = 0.045,
  duration = 0.9,
  inView = false,
  ...rest
}) {
  const reduce = useReducedMotion();
  const tokens = Array.isArray(text) ? text : [{ text }];

  const words = [];
  tokens.forEach((token, ti) => {
    const t = typeof token === 'string' ? { text: token } : token;
    if (t.br) {
      words.push({ br: true, key: `br-${ti}` });
      return;
    }
    t.text.split(' ').forEach((w, wi) => {
      if (w === '') return;
      words.push({ word: w, em: !!t.em, key: `${ti}-${wi}` });
    });
  });

  const container = {
    hidden: {},
    show: { transition: { staggerChildren: stagger, delayChildren: delay } },
  };

  const child = {
    hidden: { y: '110%', rotate: 3, opacity: 0 },
    show: {
      y: '0%',
      rotate: 0,
      opacity: 1,
      transition: { duration, ease: [0.16, 1, 0.3, 1] },
    },
  };

  const animProps = inView
    ? { initial: reduce ? 'show' : 'hidden', whileInView: 'show', viewport: { once: true, amount: 0.4 } }
    : { initial: reduce ? 'show' : 'hidden', animate: 'show' };

  const MotionTag = motion[Tag] || motion.div;

  return (
    <MotionTag className={className} variants={container} {...animProps} {...rest}>
      {words.map((w) =>
          w.br ? (
            <br key={w.key} />
          ) : (
            <span key={w.key} className="split-word" style={{ display: 'inline-block', overflow: 'hidden', verticalAlign: 'top', paddingBottom: '0.12em', marginBottom: '-0.12em' }}>
              <motion.span
                variants={child}
                style={{ display: 'inline-block', transformOrigin: '0% 100%', willChange: 'transform' }}
              >
                {w.em ? <em>{w.word}</em> : w.word}
              </motion.span>
              {' '}
            </span>
          )
      )}
    </MotionTag>
  );
}
